import React, { Component } from 'react'
import { connect } from 'react-redux';
import * as actions from './Actions';
import moment from 'moment';

import Login from './containers/Header/Login'; // TODO CAMBIAR RUTAS

const gifMorning = require('./assets/gifs/morning.gif');
const gifAfternoon = require('./assets/gifs/afternoon.gif');
const gifNight = require('./assets/gifs/night.gif');



export class Home extends Component {
    state = {
        loading: true
    };

    componentDidMount() {

        if(this.props.auth.user.id){
            document.location.href = '/me/load';
        }

        this.setState({ loading: false })
    }


    getGreetingPhrase (m) {
        var g = null;

        if(!m || !m.isValid()) { return; } //if we can't find a valid or filled moment, we return.

        var split_afternoon = 12 //24hr time to split the afternoon
        var split_evening = 17 //24hr time to split the evening
        var currentHour = parseFloat(m.format("HH"));

        if(currentHour >= split_afternoon && currentHour <= split_evening) {
            g = "Buenas tardes.";
        } else if(currentHour >= split_evening) {
            g = "Buenas noches.";
        } else {
            g = "Buenos días.";
        }

        return g;
    }


    getGreetingGif (m) {
        var g = null;

        if(!m || !m.isValid()) { return; } //if we can't find a valid or filled moment, we return.

        var split_afternoon = 12 //24hr time to split the afternoon
        var split_evening = 17 //24hr time to split the evening
        var currentHour = parseFloat(m.format("HH"));

        if(currentHour >= split_afternoon && currentHour <= split_evening) {
            g = gifAfternoon;
        } else if(currentHour >= split_evening) {
            g = gifNight;
        } else {
            g = gifMorning;
        }

        return g;
    }




    render() {
        return (
            <div className="home">
                <div className="wrapper">
                    <h1>{this.getGreetingPhrase(moment())}</h1>

                    <div className="gif">
                        <img src={this.getGreetingGif(moment())} />
                    </div>

                </div>

                <div className="login-wrapper">
                    <div className="wrapper">
                        <Login />
                    </div>
                </div>
            </div>
        )
    }

};


const mapStateToProps = (state) => ({
    auth: state.auth_reducer
});

export default connect(mapStateToProps, actions)(Home);



// WEBPACK FOOTER //
// ./src/Home.js